import React, { useEffect, useState } from 'react';
import HeaderDashboard from '../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import queryString from "query-string";
import { HttpService} from '../library';

var treeItem = "";
const Forms = () => {

    const [forms, setForms] = useState([]);
    const [fileTree, setFileTree] = useState({});
    const [searchValue, setSearchValue] = useState("");
    const [filteredForms, setFilteredForms] = useState([]);

    const getMenuForm = async () => {
        const queries = queryString.parse(window.location.search);

        await HttpService.get(`Menu/MenuFormList/${queries.menuId}`).then((response) => {
            let tree = buildTree(response.data);
            setForms(response.data);
            setFilteredForms(response.data);
            if (response.data && response.data.length > 0) {
                const parentElement = document.getElementById('file-tree-table').querySelector('tbody');
                parentElement.innerHTML = "";
                displayTreeTable(tree, response.data);
            }
        })
    }

    function sortTreeByFileCount(tree) {
        const sortedTree = {};

        for (const key in tree) {
            const currentNode = tree[key];

            const files = Object.keys(currentNode).filter(item => Object.keys(currentNode[item]).length === 0);
            const folders = Object.keys(currentNode).filter(item => Object.keys(currentNode[item]).length > 0);

            // Sort alphabetically (case-insensitive, natural order)
            files.sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));
            folders.sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));

            const newNode = {};

            // Add files first
            files.forEach(file => newNode[file] = {});

            // Recursively sort folders and add
            folders.forEach(folder => {
                newNode[folder] = sortTreeByFileCount(currentNode[folder]);
            });

            sortedTree[key] = newNode;
        }

        return sortedTree;
    }

    function sortTreeByFileCountOld(tree) {
        const sortedTree = {};

        for (const key in tree) {
            const currentNode = tree[key];

            // Get all files and folders in the current node
            const files = Object.keys(currentNode).filter(item => Object.keys(currentNode[item]).length === 0);
            const folders = Object.keys(currentNode).filter(item => Object.keys(currentNode[item]).length > 0);

            // Sort files alphabetically
            files.sort();

            // Recursively sort folders and count the files in them
            const sortedFolders = folders.sort((a, b) => {
                const aFileCount = countFiles(currentNode[a]);
                const bFileCount = countFiles(currentNode[b]);
                return bFileCount - aFileCount; // Sort in descending order based on file count
            }).map(folder => {
                // Recursively sort each folder (sub-tree)
                currentNode[folder] = sortTreeByFileCount(currentNode[folder]);
                return folder;
            });

            // Rebuild the node: files first, followed by sorted folders
            const newNode = {};

            // Add files first
            files.forEach(file => newNode[file] = {});

            // Add folders next, after sorting by file count
            sortedFolders.forEach(folder => newNode[folder] = currentNode[folder]);

            // Assign the sorted node back to the tree
            sortedTree[key] = newNode;
        }

        return sortedTree;
    }

    // Helper function to count files in a folder (leaf nodes)
    function countFiles(folder) {
        let count = 0;

        // Count files (leaf nodes) in the folder
        Object.keys(folder).forEach(item => {
            if (Object.keys(folder[item]).length === 0) {
                count++;
            } else {
                count += countFiles(folder[item]); // Recurse into subfolders
            }
        });

        return count;
    }

    async function handleOnSearch(clear = false) {
        let filtered = forms;
        if (clear) {
            setSearchValue('');
        } else {
            const lowerSearch = searchValue.toLowerCase();
            filtered = forms.filter((item) => {
                const fileName = item.NewFolderName.split('/').pop().toLowerCase();
                return fileName.includes(lowerSearch);
            });
        }

        // Rebuild tree for filtered data
        const tree = buildTree(filtered);
        const parentElement = document.getElementById('file-tree-table').querySelector('tbody');
        parentElement.innerHTML = "";
        displayTreeTable(tree, filtered);
    }

    function buildTree(paths) {
        const tree = {};
        paths.forEach(path => {
            const parts = path.NewFolderName.split('/');
            let current = tree;

            parts.forEach(part => {
                if (!current[part]) {
                    current[part] = {};
                }
                current = current[part];
            });
        });

        return sortTreeByFileCount(tree);
    }

    /**
     * @author:Sandeep Sirohi
     * @param {any} tree
     * @param {any} data
     * @param {any} level
     */
    function displayTreeTable(tree, data, level = 0) {
        const parentElement = document.getElementById('file-tree-table').querySelector('tbody');
        tree = sortTreeByFileCount(tree);
        for (const key in tree) {
            const column = document.createElement('span');
            const row = document.createElement('tr');
            const cell = document.createElement('td');
            const link = document.createElement('a');
            const icon = document.createElement('img');
            icon.style.display = "inline"; // Ensuring icon is inline with the text

            column.append(icon);
            column.append(link);
            cell.appendChild(column);
            cell.classList.add("text-left");

            link.textContent = key;
            link.target = "_blank";

            // Apply correct file/folder filtering logic
            const filteredFormsForKey = data.filter(x => {
                const fileParts = x.NewFolderName.split('/');
                const fileName = fileParts[fileParts.length - 1].toLowerCase();
                return fileName === key.toLowerCase(); // Compare file name to key
            });

            // Determine if the current node is a folder or file
            if (Object.keys(tree[key]).length > 0) {
                // It's a folder
                cell.style.fontWeight = "bold"; // Make folder name bold
                icon.src = setting.cdnUrl + "/assets/images/folder.png";
                cell.classList.add('form-folder');
            } else {
                // It's a file
                if (key.endsWith("pdf")) {
                    icon.src = setting.cdnUrl + "/assets/images/pdf.png";
                } else if (key.endsWith("xlsx")) {
                    icon.src = setting.cdnUrl + "/assets/images/excel.png";
                } else if (key.endsWith("docx")) {
                    icon.src = setting.cdnUrl + "/assets/images/word.png";
                }

                // If a file is found, link it to its URL
                if (filteredFormsForKey.length > 0) {
                    link.href = filteredFormsForKey[0].FileUrl;
                }

                cell.classList.add('form-file');
            }

            // Apply padding for tree-level indentation
            column.style.paddingLeft = `${level * 30}px`; // Adjust padding for correct indenting

            row.appendChild(cell);
            parentElement.appendChild(row);

            // Recurse for child nodes (folders)
            if (Object.keys(tree[key]).length > 0) {
                displayTreeTable(tree[key], data, level + 1); // Recurse for deeper levels
            }
        }
    }

    useEffect(() => {
        getMenuForm();
    }, [])


    return (
        <>
            <div className="DashboardWrapperChild contact-request">
                <div className="contentWrapper">
                    <HeaderDashboard title="Forms" tagLine="" />
                    <div className="container-fluid mt-80 fieldsetGridAndForm">
                        <div id="file-tree"></div>
                        <div className="mb-3 d-flex align-items-center justify-content-end">
                            <input
                                type="text"
                                id="searchBox"
                                className="form-control form-control-sm me-2"
                                placeholder="Search..."
                                style={{ width: "200px", backgroundColor:"LightGray" }}
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleOnSearch();
                                    }
                                }}
                            />
                            <button
                            
                                className="btn btn-primary btn-sm"
                                onClick={() => handleOnSearch(false)}
                                style={{
                                    backgroundColor: "#014022"
                                }}
                            >Search</button>
                            &nbsp;&nbsp;
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => handleOnSearch(true)}
                                style={{
                                    backgroundColor: "#014022"
                                }}
                            >
                                Cancel
                            </button>
                        </div>


                        <table id="file-tree-table" className=" table form-table">
                            <thead>
                                <tr>
                                    <th className="text-left">{queryString.parse(window.location.search).form}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <span></span>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div >
        </>
    )
};
export default Forms;
